import { AuthGuard } from './auth/auth.guard';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomeComponent } from './home/home/home.component';
import { NovaOcorrenciaComponent } from './home/occurrence/nova-ocorrencia/nova-ocorrencia.component';
import { AlterarSenhaComponent } from './home/navigation/alterar-senha/alterar-senha.component';
import { AreaRestritaComponent } from './home/billboard/area-restrita/area-restrita.component';
import { QuadroDeAvisosComponent } from './home/billboard/quadro-de-avisos/quadro-de-avisos.component';
import { FaleConoscoComponent } from './home/navigation/fale-conosco/fale-conosco.component';
import { AcompanhamentoComponent } from './home/occurrence/acompanhamento/acompanhamento.component';
import { HistoricoDeOcorrenciasComponent } from './home/occurrence/historico-de-ocorrencias/historico-de-ocorrencias.component';
import { RelatorioPersonalizadoComponent } from './home/reports/relatorio-personalizado/relatorio-personalizado.component';
import { RelatorioPersonalizadoCorpoComponent } from './home/reports/relatorio-personalizado-corpo/relatorio-personalizado-corpo.component';
import { HistoricoRelatoriosComponent } from './home/reports/historico-relatorios/historico-relatorios.component';
import { AlterarSenhaGuard } from './auth/alterar-senha-guard';
import { VtonlineComponent } from './vtonline/vtonline.component';
import { AuthComponent } from './auth/auth.component';
import { MenuGuard } from './auth/menu.guard';
import { VbAbastecimentoComponent } from './home/occurrence/vb-abastecimento/vb-abastecimento.component';
import { PdfViewerComponent } from './pdf-viewer/pdf-viewer.component';
import { TimeoutComponent } from './timeout/timeout.component';
import { ProcessamentoGuard } from './auth/processamento.guard';
import { DemonstrativoComponent } from './demonstrativo/demonstrativo.component';
import { ImprimirBoletoPublico } from './boleto/imprimir-boleto.component';
import { ImportarArquivoV2Component } from './home/imports-page-v2/importar-arquivo-v2/importar-arquivo-v2.component';
import { ImportarCsvV2Component } from './home/imports-page-v2/importar-csv-v2/importar-csv-v2.component';
import { ImportarPadraoV2Component } from './home/imports-page-v2/importar-padrao-v2/importar-padrao-v2.component';
import { ImportarPersonalizadaV2Component } from './home/imports-page-v2/importar-personalizada-v2/importar-personalizada-v2.component';
import { VerificarDadosImportadosV2Component } from './home/imports-page-v2/verificar-dados-importados-v2/verificar-dados-importados-v2.component';
import { PublicacaoComponent } from './publicacao/publicacao.component';
import { ResumoItensImportadosComponent } from './home/imports-page-v2/resumo-itens-importados/resumo-itens-importados.component';
import { OcorrenciaComponent } from './home/occurrence/ocorrencia.component';
import { ImportarCsvPersonalizadoComponent } from './home/imports-page-v2/importar-csv-personalizado/importar-csv-personalizado.component';
import { DashboardComponent } from './dashboard/dashboard.component';

const routes: Routes = [
  {
    path: 'publicacao',
    component: PublicacaoComponent
  },
  {
    path: 'imprimir-boleto',
    component: ImprimirBoletoPublico
  },
  {
    path: 'demonstrativo',
    component: DemonstrativoComponent
  },
  {
    path: 'pdf-viewer',
    component: PdfViewerComponent
  },
  {
    path: 'login/vtonline/vtonline.php',
    component: VtonlineComponent
  },
  {
    path: 'vtonline/vtonline.php',
    component: VtonlineComponent
  },
  {
    path: 'login/timeout',
    component: TimeoutComponent
  },
  {
    path: 'login/auth',
    component: AuthComponent
  },
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full'
  },
  {
    path: 'login',
    loadChildren: () => import('./auth/auth.module').then((m) => m.AuthModule)
  },
  {
    path: 'alterar-senha',
    component: HomeComponent,
    children: [
      {
        path: '',
        component: AlterarSenhaComponent
      },
      {
        path: ':senha',
        component: AlterarSenhaComponent
      }
    ]
  },
  {
    path: 'home',
    component: HomeComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: 'cartoes',
        loadChildren: () => import('./home/cartoes/cartoes.module').then((m) => m.CartoesModule)
      },
      {
        path: 'funcionarios',
        loadChildren: () => import('./funcionarios/funcionarios.module').then((m) => m.FuncionariosModule)
      },
      {
        path: 'dadosEmpresa',
        loadChildren: () => import('./home/register-data/dados-empresa.module').then((m) => m.DadosEmpresaModule),
        canActivate: [ProcessamentoGuard]
      },
      {
        path: 'usuarios',
        loadChildren: () => import('./usuarios/usuarios.module').then((m) => m.UsuariosModule),
        canActivate: [ProcessamentoGuard]
      },
      {
        path: 'pedidos',
        loadChildren: () => import('./home/requests/pedidos-module').then((m) => m.PedidosModule)
      },
      {
        path: 'relatorios',
        loadChildren: () => import('./home/reports/relatorios.module').then((m) => m.RelatoriosModule)
      },
      {
        path: 'roteirizacao',
        loadChildren: () => import('./roteirizacao/roteirizacao.module').then((m) => m.RoteirizacaoModule)
      },
      {
        path: 'importarDados',
        redirectTo: `importacao/importar-arquivo`,
        pathMatch: `full`
      },
      {
        path: 'importacao/importar-arquivo',
        component: ImportarArquivoV2Component,
        canActivate: [MenuGuard]
      },
      {
        path: 'importacao/importar-arquivo/verificar-dados-importados/:id',
        component: VerificarDadosImportadosV2Component,
        canActivate: [MenuGuard]
      },
      {
        path: 'importacao/importar-arquivo/csv',
        component: ImportarCsvV2Component,
        canActivate: [MenuGuard]
      },
      {
        path: 'importacao/importar-arquivo/csv-personalizado',
        component: ImportarCsvPersonalizadoComponent,
        canActivate: [MenuGuard]
      },
      {
        path: 'importacao/importar-arquivo/padrao',
        component: ImportarPadraoV2Component,
        canActivate: [MenuGuard]
      },
      {
        path: 'importacao/importar-arquivo/personalizada',
        component: ImportarPersonalizadaV2Component,
        canActivate: [MenuGuard]
      },
      {
        path: 'importacao/relatorios',
        component: RelatorioPersonalizadoComponent,
        canActivate: [MenuGuard]
      },
      {
        path: 'importarDados/importacao_dados',
        redirectTo: `importacao/relatorios`,
        pathMatch: `full`
      },
      {
        path: 'importacao/relatorios/:id',
        component: RelatorioPersonalizadoCorpoComponent,
        canActivate: [MenuGuard]
      },
      {
        path: 'relatorios/importacao/historico-relatorios/:id',
        component: HistoricoRelatoriosComponent,
        canActivate: [MenuGuard]
      },
      {
        path: 'relatorios/funcionarios/historico-relatorios/:id',
        component: HistoricoRelatoriosComponent,
        canActivate: [MenuGuard]
      },
      {
        path: 'relatorios/beneficios/historico-relatorios/:id',
        component: HistoricoRelatoriosComponent,
        canActivate: [MenuGuard]
      },
      {
        path: 'relatorios/pedidos/historico-relatorios/:id',
        component: HistoricoRelatoriosComponent,
        canActivate: [MenuGuard]
      },
      {
        path: 'relatorios/apoio/historico-relatorios/:id',
        component: HistoricoRelatoriosComponent,
        canActivate: [MenuGuard]
      },
      {
        path: 'fale-conosco',
        component: FaleConoscoComponent
      },
      {
        path: 'quadro-de-avisos',
        component: QuadroDeAvisosComponent
      },
      {
        path: 'quadro-de-avisos/:status',
        component: QuadroDeAvisosComponent
      },
      // DASH
      // {
      //   path: 'dashboard',
      //   component: DashboardComponent
      // },
      {
        path: 'nova-ocorrencia',
        component: NovaOcorrenciaComponent
      },
      {
        path: 'vb-abastecimento',
        component: VbAbastecimentoComponent
      },
      {
        path: 'ocorrencias',
        component: OcorrenciaComponent
      },
      {
        path: 'acompanhamento',
        component: AcompanhamentoComponent
      },
      {
        path: 'ocorrencias/acompanhamento',
        redirectTo: `acompanhamento`,
        pathMatch: `full`
      },
      {
        path: 'historico-de-ocorrencias',
        component: HistoricoDeOcorrenciasComponent
      },
      {
        path: 'ocorrencias/historico',
        redirectTo: `historico-de-ocorrencias`,
        pathMatch: `full`
      },
      {
        path: '**',
        component: AreaRestritaComponent
      }
    ]
  },
  {
    path: 'resumo-itens-importados',
    component: ResumoItensImportadosComponent
  },
  {
    path: ':brandName',
    children: [
      {
        path: 'login',
        loadChildren: () => import('./auth/auth.module').then((m) => m.AuthModule)
      },
      {
        path: 'login.html',
        redirectTo: 'login'
      },
      {
        path: '**',
        redirectTo: '/login'
      }
    ]
  },
  {
    path: '**',
    redirectTo: 'home',
    pathMatch: 'full'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { scrollPositionRestoration: 'enabled' })],
  exports: [RouterModule]
})
export class AppRoutingModule {}
